import type { ColorType } from '@/features/tipp-v1/tipp-v1-type';

import InfoText from '@/core/components/info-text/info-text';

export type TippV1Props = {
    colorType: ColorType;
    htmlText: string;
    iconHeight?: number;
    iconUrl: string;
    iconWidth?: number;
};

export default function TippV1({ colorType, htmlText, iconHeight = 47, iconUrl, iconWidth = 40 }: TippV1Props) {
    return (
        <InfoText
            colorType={colorType}
            fontSize={'16px'}
            icon={iconUrl}
            iconHeight={iconHeight}
            iconWidth={iconWidth}
            padding={'20px 10px'}
            text={htmlText}
        />
    );
}
